<template>
    <router-link :to="link">
        <div class="rounded-full py-2 px-4 bouton openSans font-bold">
            <i class="fab fa-facebook-f"></i>
            &nbsp;&nbsp;
            |&nbsp;&nbsp; {{ text }}
        </div>
    </router-link>
</template>

<script>
export default {
    name: "BoutonFacebook",
    props: {
        link: String,
        white: { type: Boolean, required: false, default: false },
        text: String
    }
};
</script>

<style scoped lang="scss">
.bouton {
    background-color: #3d5cc1;
    width: 50%;
    margin: 20px auto;
    padding: 15px;
    color: white;

    i {
        color: white;
    }
}
</style>
